/** The event a key command from the app shell is dispatched as, for the screen that handles it. */
export const SHELL_KEY_COMMAND_EVENT = 'featit:shell-key-command';
